// DATE formatting function utilities

export function displayDate(rawDate) {
  let dateObj = new Date(rawDate);
  let formattedDate = `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`
  return formattedDate
}
